import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90d7f77a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-divider" }
const _hoisted_2 = { class: "c-divider-text" }

import { ref, watchEffect } from 'vue';

const __default__ = {
  name:"CDivider"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showLine: { type: Boolean, default: true }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "1169c297": (_unref(lineWidth))
}))

const props = __props
let lineWidth = ref('');
watchEffect(() => {
  lineWidth.value = props.showLine ? '80%' : '0px';
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})